import React, { ReactNode } from "react";

// =============================================================================
// CARD
// =============================================================================
// PURPOSE: Container with frosted glass or solid white styling.
// VARIANTS: glass (default), solid, default (alias for glass)
// =============================================================================

interface CardProps {
  children: ReactNode;
  className?: string;
  variant?: "default" | "glass" | "solid";
  /** When provided, the card becomes a keyboard-accessible button (no transform
      hover — that blurs glass text; affordance is cursor + the caller's styling). */
  onClick?: () => void;
  testId?: string;
}

const Card: React.FC<CardProps> = ({
  children,
  className = "",
  variant = "glass",
  onClick,
  testId,
}) => {
  const variantClasses = {
    glass: "liquid-glass",
    solid: "liquid-glass-hero",
    default: "liquid-glass", // default to glass
  };

  const clickable = typeof onClick === "function";

  return (
    <div
      className={`p-6 ${variantClasses[variant]} ${className}${clickable ? " cursor-pointer" : ""}`}
      data-testid={testId}
      {...(clickable
        ? {
            role: "button" as const,
            tabIndex: 0,
            onClick,
            onKeyDown: (e: React.KeyboardEvent) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
              }
            },
          }
        : {})}
    >
      {children}
    </div>
  );
};

export default Card;
